/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-09-28 17:32:49
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2021-09-28 17:32:49
 */
import request from "@/utils/request";
const requestUrl = window.env.eventService;
// const requestUrl = '/api/event-service'
const alarmListApi = {

  /*
   * 根云平台
   *  获取故障列表
   */
  getList: data => request({
    url: `${requestUrl}/api/v1/alarm/historian`,
    method: "post",
    data
  }),

  /*
   * 中台本地
   *  获取故障列表
   */
  getLocalHostList: data => request({
    url: `${requestUrl}/api/v1/alarm/historian/list`,
    method: "post",
    data
  }),
  // 确认
  confirm: data => request({
    url: `${requestUrl}/api/v1/alarm/batch-ack`,
    method: "put",
    data
  }),

  // 关闭
  closed: alarmId => request({
    url: `${requestUrl}/api/v1/alarm/close/${alarmId}`,
    method: "put"
  }),
  alarmType: () => request({
    url: `${requestUrl}/api/v1/alarm/severities`,
    method: "post",
    data: {}
  }),
  getHomeCount: data => request({
    url: `${requestUrl}/api/v1/alarm/homepage/alarm-count`,
    method: "post",
    data
  })
};
export { alarmListApi };
